module.exports = __webpack_public_path__ + "static/media/1-normal.3a9d50fc.png";